<!-- Overlay background -->
<div class="popup-overlay" [class.active]="isPopupActive" (click)="closePopup()"></div>

<!-- Slide-in panel from right -->
<div class="feedback-panel" [class.active]="isPopupActive">
  <div class="panel-header">
    <h3 class="panel-title">Feedback Form</h3>
    <button type="button" class="close-btn" aria-label="Close" (click)="closePopup()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <div class="panel-body">
    <!-- Horizontal button options -->
    <div class="option-buttons">
      <button 
        class="option-btn" 
        [class.active]="selectedOption === 'Suggestion'"
        (click)="selectOption('Suggestion')">
        <i class="bi bi-lightbulb-fill"></i>
        <span>Suggestion</span>
      </button>
      <button 
        class="option-btn" 
        [class.active]="selectedOption === 'Enhancement'"
        (click)="selectOption('Enhancement')">
        <i class="bi bi-star-fill"></i>
        <span>Enhancement</span>
      </button>
      <button 
        class="option-btn" 
        [class.active]="selectedOption === 'Bugs'"
        (click)="selectOption('Bugs')">
        <i class="bi bi-bug-fill"></i>
        <span>Bugs</span>
      </button>
    </div>

    <!-- Feedback textarea -->
    <div class="feedback-textarea-wrapper">
      <label class="feedback-label">Your Feedback</label>
      <textarea 
        class="feedback-textarea" 
        placeholder="Share your thoughts with us..." 
        rows="6" 
        [(ngModel)]="feedbackText"></textarea>
    </div>

    <!-- Submit button -->
    <button type="submit" class="submit-btn" (click)="submitFeedback()">
      <i class="bi bi-send-fill"></i>
      <span>Submit Feedback</span>
    </button>
  </div>
</div>

<!-- Vertical left-side trigger button -->
<div class="feedback-trigger" (click)="openPopup()">
  <span class="trigger-text">
    <span class="trigger-label">Feedback</span>
    <i class="bi bi-chat-dots-fill trigger-icon"></i>
  </span>
</div>